import './contact.scss';

(function () {
    console.log(111, 'contact init');
})();
